<script setup lang="ts">
import { PSeparator } from '@pokerly/ui';

interface Props {
    mode: string | number | null;
    median: number | null;
    votesCasted: number;
    totalVoters: number;
    modeVoters: number;
    hasNumericVotes: boolean;
}

defineProps<Props>();
</script>

<template>
    <div class="flex justify-center text-center">
        <div v-if="mode !== null" class="flex flex-col gap-2 px-4 py-2">
            <h3 class="text-foreground-muted">{{ mode }}</h3>
            <div class="flex flex-col">
                <span class="paragraph-sm text-foreground-primary">Most voted (mode)</span>
                <span class="paragraph-xs text-foreground-muted"
                    >{{ modeVoters }} of {{ totalVoters }} people voted this</span
                >
            </div>
        </div>
        <PSeparator v-if="mode !== null && hasNumericVotes" orientation="vertical" />
        <div v-if="hasNumericVotes" class="flex flex-col gap-2 px-4 py-2">
            <h3 class="text-foreground-muted">{{ median }}</h3>
            <div class="flex flex-col">
                <span class="paragraph-sm text-foreground-primary">Median</span>
                <span class="paragraph-xs text-foreground-muted">Based on {{ votesCasted }} valid votes</span>
            </div>
        </div>
        <div v-if="mode === null && !hasNumericVotes" class="px-4 py-2 text-foreground-muted">No votes to analyze</div>
    </div>
</template>
